import React from 'react';
import style from './reportList.less';
import classNames from 'classnames';

function ReportList(props) {
  const { data } = props;
  return (
    <div className={style.reportListContainer}>
      {/*title*/}
      <div className={style.header}>
        <label>姓名：</label>
        <div>{data.name}</div>
      </div>
      {/*content*/}
      <div className={style.content}>
        <div className={style.contentLeft}>
          <div>
            <div className={classNames([style.labelLayout, style.gap])}>
              <label>咨询人数：</label>
              <div>{data?.served_users}</div>
            </div>
            <div className={style.labelLayout}>
              <label>咨询缺陷：</label>
              <div>{data?.features}</div>
            </div>
          </div>
          <div>
            <div className={classNames([style.labelLayout, style.gap])}>
              <label>咨询成功率：</label>
              <div>{Math.round(data?.rate24 * 100 || 0)}%</div>
            </div>
            <div className={style.labelLayout}>
              <label>新增客户：</label>
              <div>-</div>
            </div>
          </div>
        </div>
        <div className={style.contentRight}>
          <div className={classNames([style.labelLayout, style.gap])}>
            <label>咨询单：</label>
            <div>{data.invoices2}</div>
          </div>
          <div className={classNames([style.labelLayout, style.gap])}>
            <label>报价单：</label>
            <div>{data.invoices3}</div>
          </div>
          <div className={style.labelLayout}>
            <label>结算单：</label>
            <div>{data.invoices4}</div>
          </div>
        </div>
      </div>
      {/*footer*/}
      <div className={style.footer}>
        <label>登录地址：</label>
        <div>{data?.locations?.length>0 ? data?.locations[0].address : ''}</div>
      </div>
    </div>
  )
}

export default ReportList;
